import { IUser } from '@/interface/user.interface'
import { AnyMongoAbility } from '@casl/ability'
import { atom } from 'jotai'

interface IState {
  user: IUser | undefined
  tenant: any
  loading: boolean
  ability: AnyMongoAbility | undefined
}

export const authAtom = atom<IState>(null)

export const tenantImageAtom = atom<string>('')

export const isLogin = atom<boolean>(false)

export const MSSSOErrorAtom = atom<string>('')
